"use client";
import React from "react";
import { MenuToggle } from "./MenuToggle";
import { useTranslations } from "next-intl";
export type MenuButtonPropsType = {
  toggleOpen: () => void;
  open: boolean;
};
export function MenuButton({ toggleOpen, open }: MenuButtonPropsType) {
  const toggleOpenHandler = () => {
    toggleOpen();
  };
  const t = useTranslations("layout");

  return (
    <button
      onClick={toggleOpenHandler}
      className="flex flex-col gap-3 items-center cursor-pointer"
      aria-label={open ? t("close") : t("menu")}
    >
      <div
        className={`w-16 h-16 flex rounded-full   max-sm:mx-[10px] md:w-[4.3rem] md:h-[4.3rem] items-center justify-center ${
          open && "bg-white w-[5rem] h-[5rem]"
        }`}
      >
        <MenuToggle isOpen={open} />{" "}
      </div>
      <h1 className="text-[1.9rem]	hidden md:block text-white">
        {open ? t("close") : t("menu")}
      </h1>
    </button>
  );
}
